import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import { Table } from 'design-react-kit/dist/design-react-kit';
import { UniversalLink } from '@plone/volto/components';

import { ListingText } from 'design-comuni-plone-theme/components/ItaliaTheme';
import { viewDate } from 'design-comuni-plone-theme/helpers';

const messages = defineMessages({
  title: {
    id: 'bando_table_title',
    defaultMessage: 'Titolo',
  },
  description: { id: 'bando_table_description', defaultMessage: 'Descrizione' },
  bando_type: { id: 'bando_table_type', defaultMessage: 'Tipologia' },
  status: { id: 'bando_table_status', defaultMessage: 'Stato' },
  scadenza: {
    id: 'bando_table_scadenza',
    defaultMessage: 'Data di scadenza bando',
  },
});

const BandiSearchVariationTable = ({ items, isEditMode }) => {
  const intl = useIntl();

  return (
    <div className="bandi-table">
      <div className="px-2 px-lg-4">
        <Table>
          <thead>
            <tr className="d-none d-lg-table-row">
              <th>{intl.formatMessage(messages.title)}</th>
              <th>{intl.formatMessage(messages.description)}</th>
              <th>{intl.formatMessage(messages.bando_type)}</th>
              <th>{intl.formatMessage(messages.status)}</th>
              <th>{intl.formatMessage(messages.scadenza)}</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => {
              const listingText = <ListingText item={item} />;
              return (
                <tr key={index}>
                  <td className="title">
                    {item['@id'] && (
                      <UniversalLink
                        item={!isEditMode ? item : null}
                        href={isEditMode ? '#' : null}
                      >
                        {item.title ?? item.id}
                      </UniversalLink>
                    )}
                  </td>
                  <td className="description">
                    <div className="th d-lg-none">
                      {intl.formatMessage(messages.description)}
                    </div>
                    {listingText && <>{listingText}</>}
                  </td>
                  <td className="type">
                    <div className="th d-lg-none">
                      {intl.formatMessage(messages.bando_type)}
                    </div>
                    {item?.tipologia_bando?.title && (
                      <>{item.tipologia_bando.title}</>
                    )}
                  </td>
                  <td className="status">
                    <div className="th d-lg-none">
                      {intl.formatMessage(messages.status)}
                    </div>
                    {item?.bando_state?.length > 0 && (
                      <div className="bandi-in-evidence">
                        <span
                          className={cx('bando-state', {
                            open: item.bando_state?.includes('open'),
                            closed: item.bando_state?.includes('closed'),
                            scheduled: item.bando_state?.includes('scheduled'),
                            'in-progress':
                              item.bando_state?.includes('inProgress'),
                          })}
                        >
                          {item.bando_state[1]}
                        </span>
                      </div>
                    )}
                  </td>
                  <td className="pubb_date">
                    <div className="th d-lg-none">
                      {intl.formatMessage(messages.scadenza)}
                    </div>
                    {item.scadenza_bando && (
                      <>
                        {viewDate(
                          intl.locale,
                          item.scadenza_bando,
                          'DD-MM-YYYY',
                        )}
                      </>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

BandiSearchVariationTable.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkTitle: PropTypes.any,
  linkHref: PropTypes.any,
  isEditMode: PropTypes.bool,
  title: PropTypes.string,
};

export default BandiSearchVariationTable;
